import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

export const getMySections = async () => {
  const { data } = await axios.get(
    `${API}/api/class-teacher/sections`,
    {
      withCredentials: true,
    }
  );

  return data;
};

export const getMyClassStudents = async (sectionId) => {
  const { data } = await axios.get(
    `${API}/api/class-teacher/students`,
    {
      params: sectionId ? { sectionId } : {},
      withCredentials: true,
    }
  );

  return data;
};